import React, { useEffect, useState } from 'react'
import { Button, Grid, TextField, Typography } from '@material-ui/core'

import { GenericCard } from '../ModelCard'
import { SetSSCCHandler } from 'src/scanRouter/handlers'

interface LabelPrintingDisplayProps {
  handler: SetSSCCHandler
}

export const SetSSCCDisplay = (props: LabelPrintingDisplayProps) => {
  const { handler } = props
  const [, refresh] = useState({})
  const [sscc, setSSCC] = useState('')

  useEffect(() => {
    const cb = () => {
      refresh({})
    }
    handler.registerCb(cb)
    return () => handler.removeCb(cb)
  }, [handler, refresh])

  if (!handler.obj?.object || !handler.obj?.object) {
    return null
  }

  return (
    <>
      <Grid container justify="center">
        <Grid item xs={12}>
          <Typography>Setting SSCC codes for...</Typography>
        </Grid>
        <Grid item xs={12}>
          <GenericCard item={handler.obj} />
        </Grid>
        {handler.error && (
          <Grid item xs={12}>
            <Typography color="error">{handler.error}</Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography>Scan the pallet to set the SSCC code for...</Typography>
        </Grid>
        {handler.container && (
          <>
            <Grid item xs={12}>
              <GenericCard item={handler.container} />
            </Grid>
            <Grid item xs={12}>
              <form>
                <TextField autoFocus onChange={(e) => setSSCC(e.target.value)} />
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={() => {
                    handler.setSSCC(sscc)
                  }}
                >
                  Set
                </Button>
              </form>
            </Grid>
          </>
        )}
      </Grid>
    </>
  )
}
